export const authkey = "sunshine";
export const validUsers = ["Chris", "Hamish", "Reuben", "Abhinav", "Mystery"];
